export default __webpack_public_path__ + "static/media/arrowTokenX.21782d0f.svg";